import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import defined from '~app/core/defined';
import renderMarkdown from '~app/core/markdown';

import ImageCarousel from './ImageCarousel';
import PerfectScrollbarContainer from './PerfectScrollbarContainer';

const BiomeDescription = ({description, imageDefs, compact}) => {
  return (
    <div className="BiomeDescription">
      {
        defined(description) ?
          renderDescription(description, imageDefs, compact) :
          renderEmptyDescription()
      }
    </div>
  );
};

function renderDescription(description, imageDefs, compact) {
  return (
    <div className={classNames("BiomeDescription__content", {
                                "BiomeDescription__content--compact": compact,
                                "BiomeDescription__content--full": !compact,
                              })}
    >
      <ImageCarousel
        imageDefs={imageDefs}
        compact={compact}
      />

      <PerfectScrollbarContainer horizontalScroll={false}>
        <div className="BiomeDescription__text"
          dangerouslySetInnerHTML={{
            __html: renderMarkdown(description),
          }}
        />
      </PerfectScrollbarContainer>
    </div>
  );
}

function renderEmptyDescription() {
  return (
    <div className="BiomeDescription__empty">
      <p className="BiomeDescription__emptyText">
        No description is available for this location.
      </p>
    </div>
  );
}

BiomeDescription.propTypes = {
  description: PropTypes.string,
  imageDefs: PropTypes.array,
  compact: PropTypes.bool.isRequired,
};

export default BiomeDescription;



// WEBPACK FOOTER //
// ./src/components/BiomeDescription.js